import { Box, Button, VStack } from '@chakra-ui/react'
import { Link, useLocation } from 'react-router-dom'

export type SettingsNavigationItem = {
  id: string
  label: string
  to: string
}

type SettingsNavigationProps = {
  items: readonly SettingsNavigationItem[]
}

function normalizePath(pathname: string) {
  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname
}

export function SettingsNavigation({ items }: SettingsNavigationProps) {
  const { pathname } = useLocation()
  const currentPath = normalizePath(pathname)

  return (
    <Box w="80%">
      <VStack align="stretch" gap={1}>
        {items.map(item => {
          const active = normalizePath(item.to) === currentPath

          return (
            <Button
              key={item.id}
              asChild
              id={item.id}
              variant={active ? 'subtle' : 'ghost'}
              colorPalette="gray"
              justifyContent="flex-start"
            >
              <Link to={item.to}>{item.label}</Link>
            </Button>
          )
        })}
      </VStack>
    </Box>
  )
}
